import { render } from "./BtnOptionPhoneticVowel.vue?vue&type=template&id=4bbe2ec4&scoped=true"
import script from "./BtnOptionPhoneticVowel.vue?vue&type=script&lang=js"
export * from "./BtnOptionPhoneticVowel.vue?vue&type=script&lang=js"

import "@/css/components/btn-option-phonetic-vowel.css?vue&type=style&index=0&id=4bbe2ec4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbe2ec4"]])

export default __exports__